<div id="toasty" class="notification-toast-wrapper" [ngClass]="'toasty-position-bottom-right'">
  <tc-notification-toast
    *ngFor="let toast of toasts"
    [toastModel]="toast"
    (toastClick)="clickToast(toast)"
    (closeClick)="closeToast(toast)"></tc-notification-toast>
</div>
